import React from "react";
import "./BackgroundFrame.css";

import topLeftImg from "../assest/left.png";
import topRightImg from "../assest/right.png";
import iconImg from "../assest/ICSPL_LOGO 1.svg"; 

export default function BackgroundFrame({ children }) {
  return (
    <div className="bg-frame">
     
      <img src={topLeftImg} alt="" className="bg-top-left" />


      <div className="bg-top-right-wrapper">
        <img src={topRightImg} alt="" className="bg-top-right" />
        <img src={iconImg} alt="" className="bg-top-right-icon" />
      </div>

      <div className="content">{children}</div>
    </div>
  );
}
